/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_pdf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.29 4.5 8.62 1.353A1 1 0 0 0 7.857 1H2a1 1 0 0 0-1 1v11.843a1 1 0 0 0 1 1h2"
    />
    <path
      fill="#000"
      d="M5.814 8H4.141v4.667h1v-1.8h.673c1.007 0 1.594-.527 1.594-1.434C7.408 8.527 6.82 8 5.814 8Zm-.16 2.067h-.513V8.8h.513c.507 0 .74.2.74.633 0 .434-.233.634-.74.634ZM9.505 8H8.272v4.667h1.233c1.313 0 2.1-.847 2.1-2.334 0-1.486-.787-2.333-2.1-2.333Zm-.093 3.867h-.14V8.8h.14c.766 0 1.173.5 1.173 1.533 0 1.034-.407 1.534-1.173 1.534ZM15.476 8.8V8h-2.94v4.667h1V10.74h1.673v-.8h-1.673V8.8h1.94Z"
    />
  </svg>
)
export default file_pdf
